import { Component, Input, Output, EventEmitter } from '@angular/core'
import { Keyword, Writer } from '../../types'

@Component({
  selector: `accept-topic-modal`,
  template: `
    <modal (outsideClick)="onCancel()">
      <h4 *ngIf="keyword.fromBuddy" class="text-green">Accept Topic</h4>
      <h4 *ngIf="!keyword.fromBuddy" class="text-green">Accept Topic from {{ writer.shortDisplayName }}</h4>
      <p class="h4-subheader">"{{keyword.phrase}}"</p>
      <hr class="brand-hr">
      <p *ngIf="keyword.fromBuddy">
        Once you accept this topic, find it saved as “Inactive” on your Requests tab.
        Make any edits you like then click Activate when you’re ready.
        If you intend to purchase multiple posts on this topic, you'll need to edit the request accordingly.
      </p>
      <p *ngIf="!keyword.fromBuddy">
        Once you accept this topic, find it saved as “Inactive” on your Requests tab.
        Make any edits you like then click Activate when you’re ready for {{ writer.shortDisplayName }} to begin writing.
      </p>
      <form #form="ngForm" (ngSubmit)="onSubmit()">
        <div class="top-buffer">
          <button type="button" class="btn btn-default" (click)="onCancel()">Cancel</button>
          <button type="submit" class="btn btn-primary tiny-left-buffer">Confirm</button>
        </div>
      </form>
    </modal>
  `
})
export class AcceptTopicModal {
  @Input() keyword: Keyword;
  @Input() writer: Writer;
  @Output() submit: EventEmitter<number> = new EventEmitter<number>();
  @Output() cancel: EventEmitter<null> = new EventEmitter<null>();

  postLimit: number = 1;

  onSubmit(): void {
    this.submit.emit(this.postLimit)
  }

  onCancel(): void {
    this.cancel.emit(null)
  }
}
